export const companyConstants = {
  API_INSERT: '/api/company/insert',
  API_UPDATE: '/api/company/update',
  API_DELETE: '/api/company/delete',
  API_GET: '/api/company/',
  API_GETALL: '/api/company/getall',

  INSERT_REQUEST: 'COMPANY_INSERT_REQUEST',
  INSERT_SUCCESS: 'COMPANY_INSERT_SUCCESS',
  INSERT_FAILURE: 'COMPANY_INSERT_FAILURE',

  UPDATE_REQUEST: 'COMPANY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'COMPANY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'COMPANY_UPDATE_FAILURE',

  DELETE_REQUEST: 'COMPANY_DELETE_REQUEST',
  DELETE_SUCCESS: 'COMPANY_DELETE_SUCCESS',
  DELETE_FAILURE: 'COMPANY_DELETE_FAILURE',

  GET_REQUEST: 'COMPANY_GET_REQUEST',
  GET_SUCCESS: 'COMPANY_GET_SUCCESS',
  GET_FAILURE: 'COMPANY_GET_FAILURE',

  GETALL_REQUEST: 'COMPANY_GETALL_REQUEST',
  GETALL_SUCCESS: 'COMPANY_GETALL_SUCCESS',
  GETALL_FAILURE: 'COMPANY_GETALL_FAILURE',

  RESET: 'COMPANY_RESET',
  SERVICE: 'COMPANY_SERVICE',
};
